<template>
  <el-tooltip :content="placeholder" placement="top" effect="light" :open-delay="300" transition="el-zoom-in-top">
    <el-input
      v-model="filter"
      @input="onInput"
      @change="onChange"
      :placeholder="placeholder"
      clearable
    />
  </el-tooltip>
</template>

<script>
import { debounce } from 'lodash'
import { FILTER_TEMPLATES } from '../lib/list-constants'

export default {
  name: 'FilterText',
  props: {
    field: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      placeholder: this.$i18n.t('start_typing'),
    }
  },
  computed: {
    filter: {
      get() {
        return this.$get('columnFilter')(this.field.data, '')
      },
      set(filter) {
        this.$dispatch('setFilter', { data: this.field.data, filter })
      },
    },
  },
  methods: {
    onChange() {
      if (this.field.data !== FILTER_TEMPLATES.UNIVERSAL) return
      this.$dispatch('setSearchTrigger', { searchTrigger: 'filter' })
    },
    onInput: debounce(function () {
      this.$emit('apply-filter')
    }, 500),
  },
}
</script>
